import { EModelCapabilityKey } from "../types/model-capability";

/**
 * Single source of truth for model capability → chat namespace translation key.
 * Keys must exist under model_picker in i18n/locales/.../chat.json.
 * Shared by web and mobile.
 */
export const MODEL_CAPABILITY_LABEL_KEYS = {
  [EModelCapabilityKey.IMAGE_GENERATION]: "model_picker.image_generation",
  [EModelCapabilityKey.VIDEO_GENERATION]: "model_picker.video_generation",
  [EModelCapabilityKey.VISION]: "model_picker.vision",
  [EModelCapabilityKey.DOCUMENT_ANALYSIS]: "model_picker.docs",
  [EModelCapabilityKey.TOOLS]: "model_picker.tools",
} as const satisfies Record<EModelCapabilityKey, `model_picker.${string}`>;

export type TModelCapabilityLabelKey =
  (typeof MODEL_CAPABILITY_LABEL_KEYS)[EModelCapabilityKey];

export const MODEL_CAPABILITY_KEYS_ORDER: ReadonlyArray<EModelCapabilityKey> = [
  EModelCapabilityKey.IMAGE_GENERATION,
  EModelCapabilityKey.VIDEO_GENERATION,
  EModelCapabilityKey.VISION,
  EModelCapabilityKey.DOCUMENT_ANALYSIS,
  EModelCapabilityKey.TOOLS,
];
